import { render } from "./ItemDiff.vue?vue&type=template&id=063aff69"
import script from "./ItemDiff.vue?vue&type=script&lang=js"
export * from "./ItemDiff.vue?vue&type=script&lang=js"

import "./ItemDiff.vue?vue&type=style&index=0&id=063aff69&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__